export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('.home-slides').slick({
      lazyLoad: 'ondemand',
      dots: true,
      arrows: false,
      fade: true,
      infinite: true,
      autoplay: true,
      speed: 500,
      slidesToShow: 1,
      adaptiveHeight: true,
      autoplaySpeed: 4000,
      dotsClass: 'carousel-indicators',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js